// frontend/src/visitor_ai/components/CreateVisitAssistant.jsx
import React, { useState, useEffect } from "react";

/**
 * CreateVisitAssistant
 * - initialValues: object to prefill fields
 * - onSubmit(values) -> called when user clicks Create
 *
 * This replaces the stub and adds validation for required fields.
 */

const requiredFields = ["visitor_name", "host_name", "purpose"];

const CreateVisitAssistant = ({ initialValues = {}, onSubmit = () => {} }) => {
  const [form, setForm] = useState({
    visitor_name: "",
    company: "",
    host_name: "",
    date: "",
    time: "",
    purpose: "",
    mobile: "",
    email: "",
    ...initialValues
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm(prev => ({ ...prev, ...initialValues }));
  }, [initialValues]);

  const change = (k, v) => setForm({ ...form, [k]: v });

  const validate = () => {
    const err = {};
    requiredFields.forEach(f => {
      if (!form[f] || form[f].toString().trim() === "") err[f] = "Required";
    });
    // mobile or email requirement
    if (!form.mobile && !form.email) err["mobile_email"] = "Provide mobile or email";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit(form);
  };

  return (
    <div className="visitor-ai-create-visit">
      <h4>Create Visit</h4>

      <div className="form-grid">
        {["visitor_name","company","host_name","date","time","purpose","mobile","email"].map((key) => (
          <div className="field" key={key}>
            <input
              placeholder={key.replace("_", " ")}
              value={form[key] || ""}
              onChange={(e) => change(key, e.target.value)}
            />
            {errors[key] && <div className="err">{errors[key]}</div>}
          </div>
        ))}
      </div>

      {errors.mobile_email && <div className="err">{errors.mobile_email}</div>}

      <div className="actions">
        <button onClick={handleSubmit}>Create</button>
      </div>
    </div>
  );
};

export default CreateVisitAssistant;
